import React, { useState } from 'react';
import { addLexApp } from './firebaseService';
import styles from './lexapp.module.css';

export default function AddAppModal({ onClose, onAdded }) {
  const [form, setForm] = useState({
    appId: '',
    name: '',
    version: '',
    entryPoint: '',
    iconUrl: '',
    description: '',
    visibility: 'public',
  });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  function handleChange(e) {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');

    // basic validation
    if (!/^[a-z0-9-]+$/.test(form.appId)) {
      return setError('appId must be lowercase letters, numbers or hyphens only');
    }
    if (!form.name.trim()) {
      return setError('Name is required');
    }
    if (!form.entryPoint.startsWith('http')) {
      return setError('entryPoint must be a valid URL');
    }

    setSubmitting(true);
    try {
      console.log('Submitting app data:', form);
      const newAppId = await addLexApp({
        appId:      form.appId.trim(),
        name:       form.name.trim(),
        version:    form.version.trim() || '0.1.0',
        entryPoint: form.entryPoint.trim(),
        iconUrl:    form.iconUrl.trim(),
        description:form.description.trim(),
        visibility: form.visibility,
        ownerUid:   'test-uid',  // replace with actual user ID later
        createdAt:  new Date().toISOString(),
      });
      console.log('App added with document ID:', newAppId);
      onAdded();
      onClose();
    } catch (err) {
      console.error('Error adding app:', err);
      setError('Failed to register app: ' + err.message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className={styles.lexModalOverlay_lexApp}>
      <div className={styles.lexModalContent_lexApp}>
        <h2>Add New Mini-App</h2>
        <form onSubmit={handleSubmit} className={styles.lexForm}>
          <label>
            App ID
            <input
              className={styles.lexInput_lexApp}
              name="appId"
              value={form.appId}
              onChange={handleChange}
              placeholder="e.g. my-cool-app"
              required
            />
          </label>

          <label>
            Name
            <input
              className={styles.lexInput_lexApp}
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="My Cool App"
              required
            />
          </label>

          <label>
            Version
            <input
              className={styles.lexInput_lexApp}
              name="version"
              value={form.version}
              onChange={handleChange}
              placeholder="0.1.0"
            />
          </label>

          <label>
            Entry Point URL
            <input
              className={styles.lexInput_lexApp}
              name="entryPoint"
              value={form.entryPoint}
              onChange={handleChange}
              placeholder="https://your-app.com"
              required
            />
          </label>

          <label>
            Icon URL
            <input
              className={styles.lexInput_lexApp}
              name="iconUrl"
              value={form.iconUrl}
              onChange={handleChange}
              placeholder="https://…/icon.png"
            />
          </label>

          <label>
            Description
            <textarea
              className={styles.lexInput_lexApp}
              name="description"
              value={form.description}
              onChange={handleChange}
              placeholder="Short description"
            />
          </label>

          <label>
            Visibility
            <select
              className={styles.lexInput_lexApp}
              name="visibility"
              value={form.visibility}
              onChange={handleChange}
            >
              <option value="public">Public</option>
              <option value="private">Private</option>
            </select>
          </label>

          {error && <div className={styles.lexFormError}>{error}</div>}

          <div className={styles.lexFormActions}>
            <button
              type="button"
              className={`${styles.lexButton_lexApp} ${styles.lexButtonSecondary_lexApp}`}
              onClick={onClose}
              disabled={submitting}
            >
              Cancel
            </button>

            <button
              type="submit"
              className={`${styles.lexButton_lexApp} ${styles.lexButtonPrimary_lexApp}`}
              disabled={submitting}
            >
              {submitting ? 'Submitting…' : 'Add App'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
